import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { ProblemIntro } from "./components/ProblemIntro";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Pathway } from "./components/Pathway";
import { Volumes } from "./components/Volumes";
import { ClinicalTools } from "./components/ClinicalTools";
import { Bonuses } from "./components/Bonuses";
import { OfferStack } from "./components/OfferStack";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { AuthorLetter } from "./components/AuthorLetter";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3ijxoypkvdyjd">
      <MetaPixel data-id="element-1" data-mp="3ii4qhxkeukmg" />
      <main data-id="element-2" data-mp="3mlaxj7fckftz">
        <Hero data-id="element-3" data-mp="3mkre1ma1tjdu" />
        <ProblemIntro data-id="element-4" data-mp="3mkhofzsx1e8o" />
        <BeforeAfter data-id="element-5" data-mp="3mjq2zht18ww4" />
        <PainPoints data-id="element-6" data-mp="3mj6lg27aoaim" />
        <Pathway data-id="element-7" data-mp="3rbr9so7flver" />
        <Volumes data-id="element-8" data-mp="3rdaquh0wwahl" />
        <ClinicalTools data-id="element-9" data-mp="3rcsy3udgkeef" />
        <Bonuses data-id="element-10" data-mp="3recctgjguhe3" />
        <OfferStack data-id="element-11" data-mp="5yhgo69t1c8" />
        <Guarantee data-id="element-12" data-mp="67z9oh5w26u" />
        <Testimonials data-id="element-13" data-mp="4n53zyrel9i" />
        <AuthorLetter data-id="element-14" data-mp="56lhc8rh1lf" />
        <FAQ data-id="element-15" data-mp="2zl3alhpbj03q" />
        <FinalCTA data-id="element-16" data-mp="2zld4hgdhhrep" />
      </main>
      <Footer data-id="element-17" data-mp="2zmepackaxs9m" />
      <FloatingCTA data-id="element-18" data-mp="2zmo7vf30ox5a" />
      <PurchasePopup data-id="element-19" data-mp="2zng1ikd20ksx" />
    </div>;
}